<div class="ui centered grid">
  <div class="row">
    <div class="fifteen wide column">
      <h1 class="ui header" i18n="@@internal-messages">Interne Mitteilungen</h1>
    </div>
    <div class="one wide column">
      <!--CREATE NEW MESSAGE BUTTON-->
      <div class="ui right floated left labeled icon primary button" (click)="openCreateInternalMessageModal()"
           (keydown)="openCreateInternalMessageModal()" tabindex="-1" i18n="@@internal-messages-create">
        <i class="plus square icon"></i>
        Erstellen
      </div>
    </div>
  </div>

  <div class="row">
    <!--SAVED INTERNAL MESSAGES LIST-->
    @if (messages && messages.length > 0) {
      <div class="column">
        <h4 class="ui header" i18n="@@internal-messages-note">Hinweis:</h4>
        <p i18n="@@internal-messages-note-text">Interne Mitteilungen werden wöchentlich an die Mitglieder Ihrer
          Institution versandt. Einträge, die nicht gesichert sind, werden nach dem Versand gelöscht!</p>
        <app-internal-messages-list
          [internalMessages]="messages"
          [actions]="true" [showPlanned]="true" [showSaved]="true"
          [sendingDate]="getSendingDate()"
        ></app-internal-messages-list>
      </div>
    }
    <!--NO MESSAGES TEXT-->
    @if (messages && messages.length <= 0) {
      <div class="column">
        <h4 class="ui header" i18n="@@internal-messages-no-messages">Keine Mitteilungen vorhanden!</h4>
      </div>
    }
  </div>
  <!--PAGINATION-->
  @if (messages && messages.length > 0) {
    <div class="row">
      <sui-pagination [maxSize]="5" [canRotate]="true" [hasEllipses]="true"
                      [collectionSize]="pagination.collectionSize"
                      [pageSize]="pagination.pageSize" [hasNavigationLinks]="true" [hasBoundaryLinks]="true"
                      [(page)]="pagination.selectedPage" (pageChange)="updateDisplayedMessaged()">
      </sui-pagination>
    </div>
  }
</div>
